import {
  GET_AREA_LIST_FAIL,
  GET_AREA_LIST_REQUEST,
  GET_AREA_LIST_SUCCESS,
  GET_COUNTRY_LIST_FAIL,
  GET_COUNTRY_LIST_REQUEST,
  GET_COUNTRY_LIST_SUCCESS,
} from "src/constants/types";
import { with_auth } from "src/adapter";
import adapter from "src/adapter/header";
import { errorSWAL } from "../components/SweetAlert";
import i18n from "src/i18n";

export const getCountryList =
  ({ Name = "" } = {}) =>
  async (dispatch) => {
    dispatch({ type: GET_COUNTRY_LIST_REQUEST });

    try {
      const result = await adapter({
        url: `/country`,
        method: "GET",
        params: {
          Name,
        },
      });

      dispatch({
        type: GET_COUNTRY_LIST_SUCCESS,
        payload: result.Data.Country,
      });
    } catch (e) {
      dispatch({ type: GET_COUNTRY_LIST_FAIL, payload: e.data.Status });
      errorSWAL({
        text:
          e.data && e.data.Status && e.data.Status.Message
            ? e.data.Status.Message
            : i18n.t("swal.error"),
        confirmButtonText: i18n.t("utils.ok"),
      });
    }
  };

export const getAreaList =
  ({ Name = "" } = {}) =>
  async (dispatch) => {
    dispatch({ type: GET_AREA_LIST_REQUEST });

    try {
      const result = await adapter({
        url: `/area`,
        method: "GET",
        headers: with_auth(),
        params: {
          Name,
        },
      });

      dispatch({ type: GET_AREA_LIST_SUCCESS, payload: result.Data.Area });
    } catch (e) {
      dispatch({ type: GET_AREA_LIST_FAIL, payload: e.data.Status });
      errorSWAL({
        text:
          e.data && e.data.Status && e.data.Status.Message
            ? e.data.Status.Message
            : i18n.t("swal.error"),
        confirmButtonText: i18n.t("utils.ok"),
      });
    }
  };
